import React from "react";

export default function NotFound(){
  return (
      <div>
        <h1 class="bg-primary ">404 — Not Found</h1>
      </div>
    );
}